exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box_header {\n  text-align: center;\n  font-size: 20px;\n  padding: 15px;\n}\n\n.box {\n  background-color: #E5E5E5;\n}\n\n.columns.top {\n  margin-top: 60px;\n  margin-bottom: 40px;\n}\n\n.meetings {\n  margin-bottom: 60px;\n}\n\n.noteContainer {\n  text-align: center;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/admin/admin.component.css
// module id = ../../../../../src/app/admin/admin.component.css
// module chunks = main